import {
  Injectable,
  Signal,
  WritableSignal,
  computed,
  signal,
} from '@angular/core';
import { Address } from '../models/core/address.model';

@Injectable({
  providedIn: 'root',
})
export class AddressBookService {
  private _state: WritableSignal<Address | null> = signal<Address | null>(null);

  public state: Signal<Address | null> = computed(() => this._state());

  public updateState(value: Address | null) {
    this._state.set(value);
  }
}
